import { Omit } from '@40seas/entities/common';
import { SegmentEntityFieldsArray } from '@40seas/models';
import { CreditSafeCompany } from './credit-safe.company.entity';

export class CreateCreditSafeCompanyDto extends Omit(CreditSafeCompany, SegmentEntityFieldsArray) {}
